var map = {
	"./add-article-dialog": 12790,
	"./add-article-dialog.js": 12790,
	"./article-search-dialog": 75697,
	"./article-search-dialog.js": 75697,
	"./bar-code-scan-dialog": 45189,
	"./bar-code-scan-dialog.js": 45189,
	"./charge-dialog": 49730,
	"./charge-dialog.js": 49730,
	"./comment-dialog": 2065,
	"./comment-dialog.js": 2065,
	"./comment-preview-dialog": 41514,
	"./comment-preview-dialog.js": 41514,
	"./document-search-dialog": 53454,
	"./document-search-dialog.js": 53454,
	"./family-dialog": 4454,
	"./family-dialog.js": 4454,
	"./generate-stock-doc-dialog": 31483,
	"./generate-stock-doc-dialog.js": 31483,
	"./in-lots-dialog": 63068,
	"./in-lots-dialog.js": 63068,
	"./in-serials-dialog": 18943,
	"./in-serials-dialog.js": 18943,
	"./inventory-lots-dialog": 8239,
	"./inventory-lots-dialog.js": 8239,
	"./inventory-serials-dialog": 72642,
	"./inventory-serials-dialog.js": 72642,
	"./lots-dialog": 22278,
	"./lots-dialog.js": 22278,
	"./merge-documents-dialog": 28327,
	"./merge-documents-dialog.js": 28327,
	"./out-lots-dialog": 82711,
	"./out-lots-dialog.js": 82711,
	"./out-serials-dialog": 7066,
	"./out-serials-dialog.js": 7066,
	"./price-request-response-dialog": 76907,
	"./price-request-response-dialog.js": 76907,
	"./provider-dialog": 33913,
	"./provider-dialog.js": 33913,
	"./provider-search-dialog": 65814,
	"./provider-search-dialog.js": 65814,
	"./serials-dialog": 26785,
	"./serials-dialog.js": 26785,
	"./tariff-details-dialog": 14621,
	"./tariff-details-dialog.js": 14621,
	"./warehouse-dialog": 73603,
	"./warehouse-dialog.js": 73603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69779;